import React from "react";
import { withRouter } from "react-router-dom";

import { withStyles } from "@material-ui/core/styles";
import { useTheme } from "@material-ui/core";
import { withNamespaces } from "react-i18next";
import Slider from "rc-slider";

const { createSliderWithTooltip } = Slider;
const SliderWithTooltip = createSliderWithTooltip(Slider);

const styles = (theme) => ({
  barContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
  },
  barIcon: {
    minWidth: "31px",
    height: "31px",
    marginRight: "8px",
    border: "1px solid " + theme?.colors?.presale?.cardTitle,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0px",
    borderRadius: "8px",
  },
  barImage: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
  },
  barSetting: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
    width: "100%",
  },
  barTitle: {
    fontFamily: "Poppins",
    fontSize: "14px",
    letterSpacing: "0px",
    color: "#A0A0A0",
  },
  barTickBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
  },
  barStart: {
    fontFamily: "Poppins",
    fontSize: "14px",
    letterSpacing: "0px",
    color: theme?.colors?.presale?.cardTitle,
    marginRight: "6px",
    textAlign: "left",
    minWidth: "20px",
  },
  barEnd: {
    fontFamily: "Poppins",
    fontSize: "14px",
    letterSpacing: "0px",
    color: theme?.colors?.presale?.cardTitle,
    marginLeft: "10px",
    textAlign: "right",
    minWidth: "20px",
  },
  barTickBar: {
    width: "100%",
    height: "10px",
    "& > .rc-slider": {
      padding: "0px",
      height: "4px",
    },
  },
  sliderLabels: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    marginTop: "10px",
  },
  sliderLabelMin: {
    color: theme?.colors?.presale?.cardTitle,
  },
  sliderLabelMax: {
    color: theme?.colors?.presale?.cardTitle,
  },
});

const SliderBar = ({
  title,
  color,
  icon,
  min,
  max,
  value,
  onChange,
  tipFormatter,
  classes,
}) => {
  const theme = useTheme();
  return (
    <div className={classes.barContainer}>
      {icon && (
        <div className={classes.barIcon}>
          <img src={icon} alt="icon" className={classes.barImage} />
        </div>
      )}
      <div className={classes.barSetting}>
        <span className={classes.barTitle}>{title}</span>
        <div className={classes.barTickBox}>
          <div className={classes.barTickBar}>
            <SliderWithTooltip
              railStyle={{
                height: "8px",
              }}
              trackStyle={{ backgroundColor: color, height: "8px" }}
              handleStyle={{
                backgroundColor: theme?.colors?.wallet?.buttonBackground,
                border: "none",
                width: "22px",
                height: "22px",
                marginTop: "-6px",
              }}
              min={min}
              max={max}
              defaultValue={0}
              value={value}
              tipFormatter={tipFormatter}
              tipProps={{
                placement: "bottom",
              }}
              onChange={(newValue) => {
                onChange(newValue);
              }}
            />
            <div className={classes.sliderLabels}>
              <span className={classes.sliderLabelMin}>{min}</span>
              <span className={classes.sliderLabelMax}>{max}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withNamespaces()(withRouter(withStyles(styles)(SliderBar)));
